import axios from 'axios';
import store from '@/store/index';
import {debounce} from '@/helpers';

const ijstijd = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        Accept: 'application/json'
    }
});

const sportid = axios.create({
    baseURL: process.env.VUE_APP_SPORTID_API,
    headers: {
        Accept: 'application/json'
    }
});

sportid.interceptors.request.use((config) => {
    const api_token = store.state.sportid.api_token;

    if (api_token) {
        config.headers['Authorization'] = `Bearer ${api_token.token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

sportid.interceptors.response.use((response) => {
    return response;
}, ({response}) => {
    if (response.status === 401) {
        store.dispatch('sportid/clear');
    }

    if(response.status.toString().indexOf(5) === 0) {
        alert('Er is een fout opgetreden probeer het later nogmaals.');
    }

    return Promise.reject(response);
});

ijstijd.interceptors.request.use((config) => {
    const api_token = store.state.sportid.api_token;

    if (api_token) {
        config.headers['Authorization'] = `Bearer ${api_token.token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

ijstijd.interceptors.response.use((response) => {
    return response;
}, ({response}) => {
    if (response.status === 401) {
        store.dispatch('sportid/clear');
    }

    if(response.status.toString().indexOf(5) === 0) {
        alert('Er is een fout opgetreden probeer het later nogmaals.');
    }

    return Promise.reject(response);
});

export default {
    ijstijd: {
        register: debounce(data => {
            return ijstijd.post('auth/register', data);
        }),

        getProducts(params = {}, limit = 24) {
            return ijstijd.get('products', {
                params: {...params, limit},
            });
        },
        getProduct(id = null, campaign = null) {
            return ijstijd.get(`products/${id}?include=location.openinghours`, {
                params:{
                    campaign
                }
            });
        },
        order(data) {
            return ijstijd.post('orders', data);
        },
        partnerorder(data) {
            return ijstijd.post(`partners/orders`, data);
        },
        get(url) {
            return ijstijd.get(url);
        },
        patch(data) {
            return ijstijd.put('profiles/me', data);
        }
    },
    sportid: {
        login(data) {
            return sportid.post('auth/login', data);
        },
        logout(data) {
            return sportid.post('auth/logout', data);
        },
        tokenRefresh(data) {
            return sportid.post('token/refresh', data);
        }
    }
};
